import { COMPANY_ID } from '../util/constant';
import { getStoredData, get_auth_key } from '../util';

export const getLocationsForUser = (locations, type, admins) => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  if (admins) {
    return locations.filter((item) => item.type === type && item.companyId === COMPANY_ID);
  }
  return locations.filter(
    (item) => storedData?.locationId.includes(item?.id) && item?.type === type && item?.companyId === parseInt(COMPANY_ID)
  );
};
